import { cx } from "../../lib/cx";
import styles from "./Spinner.module.css";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  /** Announced to assistive technology; omit when a parent already announces busy state. */
  label?: string;
  className?: string;
}

export function Spinner({ size = "md", label, className }: SpinnerProps) {
  const classes = cx(styles.spinner, className);
  if (!label) return <span className={classes} data-size={size} aria-hidden="true" />;
  return <span className={classes} data-size={size} role="status" aria-label={label} />;
}
